import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { FlaskConical } from 'lucide-react'
import { btnPrimary, SkeletonRows } from '@/components/rm'
import { useT } from '@/i18n'
import { supabase } from '@/lib/supabase'
import { pesoFromCentavos } from '@/lib/ph'
import { testPay } from '@/lib/escrow'

// Spec 008. The test provider's checkout: stands in for PayMongo until the gates are passed.
export const Route = createFileRoute('/_client/pay/test/$payment')({ component: TestCheckout })

function TestCheckout() {
  const { payment } = Route.useParams()
  const { t } = useT()
  const navigate = useNavigate()
  const [busy, setBusy] = useState(false)
  const q = useQuery({
    queryKey: ['test-payment', payment],
    queryFn: async () => {
      const { data } = await supabase.from('mkt_payment').select('id, booking_id, amount_centavos, status, method').eq('id', payment).maybeSingle()
      return data as { id: string; booking_id: string; amount_centavos: number; status: string; method: string } | null
    },
  })
  if (q.isLoading) return <SkeletonRows count={3} />
  const p = q.data
  if (!p) return <p className="text-[14px] text-token-secondary">{t('tasks.notFound')}</p>
  return (
    <div className="mx-auto max-w-sm space-y-4 rounded-[16px] border border-dashed border-token-warning bg-token-surface p-5 text-center">
      <FlaskConical className="mx-auto h-8 w-8 text-token-warning" />
      <h1 className="font-display text-[20px] font-bold text-token-primary">{t('pay.testTitle')}</h1>
      <p className="text-[13.5px] text-token-secondary">{t('pay.testBody')} · {p.method.toUpperCase()}</p>
      <button type="button" disabled={busy || p.status !== 'pending'} className={`${btnPrimary} h-11 w-full justify-center`} onClick={async () => {
        setBusy(true)
        try { await testPay(p.id) } finally { navigate({ to: '/bookings/$id', params: { id: p.booking_id } }) }
      }}>{t('pay.testPay', { price: pesoFromCentavos(p.amount_centavos) })}</button>
    </div>
  )
}
